"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _v = _interopRequireDefault(require("uuid/v1"));
var _ = require("./");
var _components = _interopRequireWildcard(require("../../components"));
var Components = _components;
var FormComponents = _interopRequireWildcard(require("../../components/Forms"));
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _2 = require("../");
var _icon = _interopRequireDefault(require("./../../../fonts/icon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const mapStateToProps = (state, props) => {
  if (!state[props.entity.plural]) console.error(`There is no ${props.entity.plural} in state. Maybe you have forgotten to register the reducer.`);
  return {
    [props.entity.plural]: state[props.entity.plural]
  };
};
const mapDispatchToProps = (dispatch, props) => {
  const {
    actions
  } = props;
  return {
    getAll: (0, _redux.bindActionCreators)(actions.getAll, dispatch)
  };
};
class Table extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "toggleModalDialog", () => {
      this.setState({
        modalDialogOpen: !this.state.modalDialogOpen
      });
    });
    _defineProperty(this, "handleDeleteSelected", () => {
      this.props.onDelete(this.props.selection);
      this.toggleModalDialog();
    });
    _defineProperty(this, "columnSort", selectedColumn => {
      const {
        [this.props.entity.plural]: entity
      } = this.props;
      let storeOrder = entity.list.order;
      const {
        onSort
      } = this.props;
      let sortBy = Array.from(storeOrder);
      let sortColumn = null;
      let sortOrder = null;
      let sortIndex = null;
      new Promise(resolve => {
        if (!storeOrder.length) {
          /* First column sorting */

          sortBy.push({
            column: selectedColumn,
            order: "ASC"
          });
          this.setState({
            sorted: true,
            previousSelectedColumn: selectedColumn,
            sortBy: sortBy
          });
          return resolve();
        } else {
          let isColumnSorted = false;
          for (let i in sortBy) {
            /* Check which column was clicked */

            if (sortBy[i].column === selectedColumn) {
              isColumnSorted = true;
              sortColumn = sortBy[i].column;
              sortOrder = sortBy[i].order;
              sortIndex = i;
            }
          }
          switch (sortOrder) {
            case null:
              if (isColumnSorted === false) {
                sortBy.push({
                  column: selectedColumn,
                  order: "ASC"
                });
              } else {
                for (var x in sortBy) {
                  if (sortBy[x].column === sortColumn) {
                    sortBy[x].order = "ASC";
                  }
                }
              }
              this.setState({
                sorted: true,
                previousSelectedColumn: selectedColumn,
                sortBy: sortBy
              });
              return resolve();
            case "ASC":
              for (var i in sortBy) {
                if (sortBy[i].column === sortColumn) {
                  sortBy[i].order = "DESC";
                }
              }
              this.setState({
                sorted: true,
                previousSelectedColumn: selectedColumn,
                sortBy: sortBy
              });
              return resolve();
            case "DESC":
              for (var j in sortBy) {
                if (sortBy[j].column === sortColumn) {
                  sortBy.splice(j, 1);
                }
              }
              this.setState({
                sorted: sortBy.length ? true : false,
                previousSelectedColumn: null,
                sortBy: sortBy
              });
              return resolve();
            default:
              for (var k in sortBy) {
                if (sortBy[k].column === sortColumn) {
                  sortBy.splice(k, 1);
                }
              }
              this.setState({
                sorted: sortBy.length ? true : false,
                previousSelectedColumn: null,
                sortBy: sortBy
              });
              return resolve();
          }
        }
      }).then(() => {
        onSort(sortBy);
      });
    });
    this.state = {
      sorted: false,
      previousSelectedColumn: null,
      sortBy: [],
      modalDialogOpen: false
    };
  }
  render() {
    const {
      columns,
      selection,
      values,
      fetching,
      fetched,
      onClick,
      onSelect,
      onSelectAll,
      onChange,
      [this.props.entity.plural]: entity,
      ...rest
    } = this.props;

    // show checkbox based on permission
    const entityName = this.props.entity.plural;
    let deletePermission = [];
    let developerPermission = [];
    if (this.props.auth !== undefined) {
      deletePermission = this.props.auth.me.data.FlatPermissions.filter(permission => permission.Value === `control.${entityName}/delete`);
      developerPermission = this.props.auth.me.data.FlatPermissions.filter(permission => permission.Value === `*`);
    }
    let storeOrder = entity.list.order;
    const allSelected = values ? selection.length === values.length : false;
    const uuid = (0, _v.default)();
    if (!fetched || fetching) return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_2.Spinner, null));
    return /*#__PURE__*/_react.default.createElement("div", null, selection.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: "d-flex justify-content-between align-items-center",
      style: {
        height: "3rem"
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "text-left mt-1 mb-3"
    }, selection.length, " item", selection.length !== 1 && `s`, " selected"), /*#__PURE__*/_react.default.createElement("div", {
      className: "text-right"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "btn btn-lg btn-transparent mt-1 mb-3",
      onClick: this.toggleModalDialog
    }, /*#__PURE__*/_react.default.createElement(_icon.default, {
      icon: "delete",
      size: 20
    })))), /*#__PURE__*/_react.default.createElement("table", {
      className: "table table-hover"
    }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, deletePermission.length > 0 || developerPermission.length > 0 || entityName === "translationentries" ? /*#__PURE__*/_react.default.createElement("th", {
      className: "align-top table-header",
      scope: "col"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "custom-control custom-checkbox"
    }, /*#__PURE__*/_react.default.createElement("input", {
      id: uuid,
      type: "checkbox",
      className: "custom-control-input",
      onChange: event => onSelectAll(event.target.checked),
      checked: allSelected
    }), /*#__PURE__*/_react.default.createElement("label", {
      className: "custom-control-label d-block",
      htmlFor: uuid
    }))) : null, columns.map((column, index) => /*#__PURE__*/_react.default.createElement(_.TableColumnHeader, {
      key: index,
      column: column,
      sortBy: storeOrder,
      onSort: () => this.columnSort(columns[index].key)
    })))), /*#__PURE__*/_react.default.createElement("tbody", null, fetched && values.map((row, i) => {
      const selected = selection.some(selected => selected === row.Id);
      return /*#__PURE__*/_react.default.createElement("tr", {
        key: `${row.Id || i}-row`,
        className: selected ? "table-active" : ""
      }, deletePermission.length > 0 || developerPermission.length > 0 || entityName === "translationentries" ? /*#__PURE__*/_react.default.createElement("th", {
        scope: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "custom-control custom-checkbox"
      }, /*#__PURE__*/_react.default.createElement("input", {
        id: row.Id,
        type: "checkbox",
        className: "custom-control-input",
        onChange: event => onSelect(event.target.checked, row.Id),
        checked: selected,
        disabled: !fetched
      }), /*#__PURE__*/_react.default.createElement("label", {
        className: "custom-control-label d-block",
        htmlFor: row.Id
      }))) : null, columns.map((column, index) => {
        const value = column.type === "Join" ? row[column.entities.join] : row[column.key];
        const Component = column.component || (column.editable && column.type !== "Bool" ? FormComponents[column.type] : column.type === "Bool" ? () => /*#__PURE__*/_react.default.createElement("div", null, value ? value : "") : Components[column.type] || (() => /*#__PURE__*/_react.default.createElement("div", null, value ? JSON.stringify(value) : "")));
        let editableCellMinWidth = 0;
        if (column.editable === true) editableCellMinWidth = "10rem";
        return /*#__PURE__*/_react.default.createElement("td", {
          key: `${row.Id || index}-col-${index}`,
          className: "position-relative",
          style: {
            minWidth: editableCellMinWidth
          }
        }, onClick && row.Id && /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          to: onClick(row.Id),
          className: "table-link"
        }), /*#__PURE__*/_react.default.createElement("span", {
          className: "position-relative",
          style: {
            cursor: "pointer",
            maxHeight: "200px",
            overflow: "hidden",
            WebkitLineClamp: 5,
            WebkitBoxOrient: "vertical",
            display: "-webkit-box"
          }
        }, onClick && row.Id && /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          to: onClick(row.Id),
          className: "table-link"
        }), /*#__PURE__*/_react.default.createElement(Component, _extends({}, rest, {
          row: row,
          value: value,
          format: column.format,
          fetched: fetched,
          fetching: fetching,
          schema: column,
          onChange: val => onChange(column.key || column.id, val, row.Id),
          edit: column.editable
        }))));
      }));
    }))), /*#__PURE__*/_react.default.createElement(_components.ModalDialog, {
      isOpen: this.state.modalDialogOpen,
      headerText: `You will delete ${this.props.selection.length} item${this.props.selection.length !== 1 ? `s` : ``}`,
      bodyText: "Are you sure? This action cannot be undone.",
      buttonSecOnClick: this.toggleModalDialog,
      buttonSecText: "Cancel",
      buttonPrimOnClick: this.handleDeleteSelected,
      buttonPrimText: "Delete"
    }));
  }
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Table);
module.exports = exports.default;